export class CaptureScope {}
export class AssignScope {}
export class IncrementScope {}
export class DecrementScope {}
